import {
  CHANGE_TOTAL_PRE_TAX,
  CHANGE_TAX_COST,
  CHANGE_TIP_COST,
  ADD_ITEM,
  REMOVE_ITEM
} from './action-types'

export function changeTotalPreTax (totalPreTax) {
  return {
    type: CHANGE_TOTAL_PRE_TAX,
    payload: {
      totalPreTax
    }
  }
}

export function changeTaxCost (taxCost) {
  return {
    type: CHANGE_TAX_COST,
    payload: {
      taxCost
    }
  }
}

export function changeTipCost (tipCost) {
  return {
    type: CHANGE_TIP_COST,
    payload: {
      tipCost
    }
  }
}

export function addItem (item) {
  return {
    type: ADD_ITEM,
    payload: {
      item
    }
  }
}

export function removeItem (index) {
  return {
    type: REMOVE_ITEM,
    payload: {
      index
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/core/receipt/actions.js
 **/